module.exports = __webpack_public_path__ + "img/Mar_Logotipo.cf7d3d48.svg";